// See discussion in https://github.com/iknow/issues/issues/116
// why there's only one size of icon used here
const ICON_SIZES = [192];

const getUrl = (path, size) => `${path}/${size}x${size}.png`;

export const generateManifestContent = path => ({
  icons: ICON_SIZES.map(size => ({
    src: getUrl(path, size),
    sizes: `${size}x${size}`,
    type: 'image/png',
  })),
});

export const getLegacyNodeDataForManifestContent = (path => {
  const nodeData = [];

  ICON_SIZES.forEach(size => {
    nodeData.push({
      rel: 'icon',
      href: getUrl(path, size),
      sizes: `${size}x${size}`,
    });
    nodeData.push({
      rel: 'apple-touch-icon',
      href: getUrl(path, size),
      sizes: `${size}x${size}`,
    });
  });

  return nodeData;
});

